import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/manage',
    name: 'manage',
    component: ()=> import ('../views/ManagmentView.vue')
  },
  {
    path: '/',
    name: 'main',
    component: ()=> import ('../views/MainPage.vue')
  },
  {
    path:'/login',
    name: 'login',
    component: ()=> import ('../views/LoginView.vue')
  },
  {
    path:  '/static',
    name: 'static',
    component: ()=> import ('../views/StaticView.vue')
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to) => {  
  if (to.name === 'manage'){
    return;
  } else if (to.name === 'login' ) {
    return;
  }

  
  if (!localStorage.getItem('loginToken')) {
    return { path: '/login' }
  }
});
export default router